import { useToken } from "../../Hooks/useToken"
import { Default } from "../../pages/auth/default"

const RouteRequiresLogin = (props: any) => {
   const userIsLogged = useToken()

   return userIsLogged ? props.component : <Default />
};

export default RouteRequiresLogin;